import React from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  InputGroup,
  Textarea as ChakraTextearea,
  TextareaProps as ChakraTexteareaProps,
} from '@chakra-ui/react';
import { FieldError, UseFormRegister } from 'react-hook-form';

interface TextareaProps extends ChakraTexteareaProps {
  name: string;
  label?: string;
  error?: FieldError;
  register?: UseFormRegister<any>;
  isRequired?: boolean;
}

export const Textarea: React.VFC<TextareaProps> = ({
  name,
  label,
  register = () => ({}),
  error = null,
  isRequired = false,
  ...props
}) => {
  return (
    <FormControl isInvalid={!!error}>
      {!!label && (
        <FormLabel fontSize="14px" htmlFor={name}>
          {label} {isRequired && <span style={{ color: 'red' }}>*</span>}
        </FormLabel>
      )}
      <InputGroup>
        <ChakraTextearea
          bg="gray.100"
          borderColor="gray.300"
          _hover={{
            borderColor: 'gray.500',
          }}
          _placeholder={{
            color: 'gray.500',
          }}
          {...props}
          {...register(name)}
        />
      </InputGroup>
      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};
